// extracted by mini-css-extract-plugin
export default {"container":"Subtitle_container__ymcM0","heading":"Subtitle_heading__McnhF"};